import { Component, Input, forwardRef, ElementRef, OnDestroy, OnInit } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { DomSanitizer, SafeUrl } from '@angular/platform-browser';

@Component({
  selector: 'app-file-dropzone',
  templateUrl: './file-dropzone.component.html',
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      useExisting: forwardRef(() => FileDropzoneComponent),
      multi: true,
    },
  ],
})
export class FileDropzoneComponent implements ControlValueAccessor, OnDestroy, OnInit {
  @Input() accept = '';
  /** Sanitized blob URL for SVG preview (Angular strips blob: in img src otherwise) */
  _filePreviewSafeUrl: SafeUrl | null = null;

  constructor(
    private elementRef: ElementRef,
    private sanitizer: DomSanitizer,
  ) {}

  ngOnInit() {
    if (!this.accept) {
      this.accept = this.elementRef.nativeElement.getAttribute('accept') || '';
    }
  }

  _fileData: any;
  _file: File | null = null;
  private _filePreviewUrl: string | null = null;
  private onChange: (m: any) => void = () => {};
  private onTouched: (m: any) => void = () => {};

  public writeValue(value: any): void {
    this._fileData = value;
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  onFileChange(event) {
    this.clearSvgPreview();
    const reader = new FileReader();
    if (event.addedFiles && event.addedFiles.length) {
      const file = event.addedFiles[0];
      this._file = file;
      if (file.type === 'image/svg+xml') {
        const blobUrl = URL.createObjectURL(file);
        this._filePreviewUrl = blobUrl;
        this._filePreviewSafeUrl = this.sanitizer.bypassSecurityTrustUrl(blobUrl);
      } else {
        this._filePreviewSafeUrl = null;
      }
      reader.readAsDataURL(file);
      reader.onload = () => {
        this._fileData = reader.result;
        this.onChange(this._fileData);
      };
    }
  }

  private clearSvgPreview(): void {
    if (this._filePreviewUrl) {
      URL.revokeObjectURL(this._filePreviewUrl);
      this._filePreviewUrl = null;
    }
    this._filePreviewSafeUrl = null;
  }

  ngOnDestroy() {
    this.clearSvgPreview();
  }
}
